import api from "!../../../../Faraz.React/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../Faraz.React/node_modules/css-loader/dist/cjs.js!./Notify.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};